"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allEpics = void 0;
const redux_observable_1 = require("redux-observable");
const basicInformation_1 = require("./basicInformation");
const finishings_1 = require("./finishings");
const list_1 = require("./list");
const userGroups_1 = require("./userGroups");
const messages_1 = require("./messages");
const questions_1 = require("./questions");
const message_1 = require("./message");
const participants_1 = require("../bid/participants");
const tender_1 = require("../bid/tender");
const _currentBid = require("../../modules/bid/current/epics");
const _folderTree = require("../../modules/files/tree/epics");
const _billingInformation = require("../../modules/billingInformation/epics");
const _preview = require("../../modules/files/preview/epics");
const _revisions = require("../../modules/revisions/epics");
const reliablePartnerSettings_1 = require("./reliablePartnerSettings");
const currentBid = _currentBid.default('current-bid');
const currentAddendum = _currentBid.default('current-addendum');
const folderTree = _folderTree.default('bid');
const preview = _preview.default('tender-documents');
const revisions = _revisions.default('tender-documents');
const billingInformation = _billingInformation.default('@sok/bid');
exports.allEpics = redux_observable_1.combineEpics(
// Billing informations
billingInformation.fetchBillingInformations, 
// Current
currentBid.fetch, currentBid.provides, currentAddendum.fetch, currentAddendum.provides, 
// Basic Information
basicInformation_1.createBid, basicInformation_1.updateBid, basicInformation_1.saveOpeningEvent, 
// Finishings
finishings_1.fetchFinishings, 
// List
list_1.fetchBids, list_1.bookmarkBid, list_1.removeBid, list_1.copyBid, 
// Participants
participants_1.fetchParticipants, participants_1.removeParticipants, participants_1.addParticipants, participants_1.toggleParticipant, participants_1.copyParticipants, 
// UserGroups
userGroups_1.fetchUserGroups, 
// Messages
messages_1.listMessages, 
// Message
message_1.getMessage, message_1.sendMessage, message_1.getPendingFiles, message_1.getFiles, message_1.prepareUpload, folderTree.fetchTree, folderTree.copyFiles, 
// Questions
questions_1.listQuestions, questions_1.addQuestion, questions_1.answerQuestions, questions_1.excludeQuestions, questions_1.getQuestionFiles, questions_1.deleteQuestionFiles, 
// Tender
tender_1.fetchTender, tender_1.getTenderFiles, tender_1.fetchNotes, tender_1.addNote, tender_1.editNote, tender_1.fetchSchema, tender_1.approveSection, tender_1.declineSection, tender_1.getTenderPendingFiles, tender_1.submitTender, tender_1.fetchReliablePartnerReport, 
// Reliable Partner Settings
reliablePartnerSettings_1.setVastuuApiIdentifier, reliablePartnerSettings_1.unsetVastuuApiIdentifier, 
// Tender card preview
revisions.fetchRevisionsList, preview.convert, preview.fetchTree);
//# sourceMappingURL=index.js.map